// src/utils/permissionUtils.js

export const validatePermission = (path, permissions, mapping) => {
    const requiredPermission = Object.keys(mapping).find(
      (key) => mapping[key] === path
    );
    return requiredPermission
      ? permissions.includes(parseInt(requiredPermission, 10))
      : false;
  };

// The campaign permission vocabulary is asymmetric per queue (see
// permissionUtils.test.js): some queues define :Edit, some only :Delete, some
// only :View. A write control is gated on the grant the vocabulary defines for
// that queue; when it defines no write grant the control is not gated here
// (undefined), so callers test `!== false`.
const definedPath = (path, mapping) =>
  Object.keys(mapping || {}).some((key) => mapping[key] === path);

const resolveGrant = (prefix, order, permissions, mapping) => {
  for (const action of order) {
    const path = `${prefix}:${action}`;
    if (definedPath(path, mapping)) return validatePermission(path, permissions || [], mapping);
  }
  return undefined;
};

export const canWriteQueue = (prefix, permissions, mapping) =>
  resolveGrant(prefix, ["Edit", "Delete"], permissions, mapping);

export const canDeleteQueue = (prefix, permissions, mapping) =>
  resolveGrant(prefix, ["Delete", "Edit"], permissions, mapping);
